import React, {useState, useEffect} from "react"
import {Select} from "@irati/ui/src/FormItem"
import {useCustomRewardsQuery} from "@irati/custom-reward/hooks"
import Flex from "@irati/ui/src/Flex"
import Error from "@irati/ui/src/Loading/Error"
import Expander from "@irati/ui/src/Expander"
import {Body, Label} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {CustomRewardStatus} from "@irati/types"
interface Props {
  onChange: (customRewardId: string) => void
  defaultValue?: string | null
  regions?: string[]
}
type CustomRewardsOption = {
  value: string
  label: string
  policy: string
}
const CustomRewardSelect = (props: Props) => {
  const {onChange, defaultValue, regions} = props
  const theme = useTheme()
  const [customRewardOptions, setCustomRewardOptions] = useState<CustomRewardsOption[]>()
  const [selectedCustomRewardOption, setSelectedCustomRewardOption] = useState<CustomRewardsOption>()
  const {data} = useCustomRewardsQuery(
    {
      filters: {
        locations: regions,
        status: CustomRewardStatus.Active
      }
    },
    {fetchPolicy: "cache-and-network"}
  )
  useEffect(() => {
    if (!data) return
    const newCustomRewardsOptions = data.map((customReward) => ({
      value: customReward.uuid,
      label: customReward.title,
      policy: customReward.policy
    }))
    setCustomRewardOptions(newCustomRewardsOptions)
    if (defaultValue) {
      const defaultSelectedCustomRewardOption = newCustomRewardsOptions.find(({value}) => defaultValue === value)
      setSelectedCustomRewardOption(defaultSelectedCustomRewardOption)
    }
    if (selectedCustomRewardOption) {
      const isIncludedSelectedCustomReward = newCustomRewardsOptions.some(({value}) => selectedCustomRewardOption.value === value)
      if (!isIncludedSelectedCustomReward) {
        setSelectedCustomRewardOption(null)
        onChange(null)
      }
    }
  }, [data])
  const onSelectCustomReward = (customRewardId: string) => {
    const newSelectedCustomRewardOption = customRewardOptions?.find(({value}) => customRewardId === value)
    setSelectedCustomRewardOption(newSelectedCustomRewardOption)
    onChange(customRewardId)
  }
  return (
    <Flex direction="column" marginBottom={2}>
      <Select
        id="selectCustomReward"
        isClearable={false}
        isSearchable={false}
        options={customRewardOptions}
        hideLabel
        flush
        name="selectCustomReward"
        placeholder="recognition.reward.select.placeholder"
        onChange={onSelectCustomReward}
        value={selectedCustomRewardOption}
      />
      {customRewardOptions?.length === 0 && <Error errorMsg="platform.recognition.customReward.noCustomRewards" />}
      {selectedCustomRewardOption && (
        <Expander
          HeaderLabel={() => (
            <Flex gap={1} alignItems="center" marginBottom={1}>
              <Icon icon={IconTypes.plus} size={12} color={theme.colors.perkbox.blue} />
              <Body color={theme.colors.perkbox.blue} small>
                <FormattedMessage id="recognition.customRewards.lbl.expandDetails" />
              </Body>
            </Flex>
          )}
          showArrow={false}>
          <Label>{selectedCustomRewardOption.policy}</Label>
        </Expander>
      )}
    </Flex>
  )
}

export default CustomRewardSelect
